import req from "@/utils/axios.js";
export default {
    // 门店进货商品列表
    getstoreshoplist(data){
        return req.get("/wxShop/product/list",{
            ...data
        })
    },
    //分类
    getshopcategory(){
        return req.get("/wxShop/product/category/list")
    },
    //购物车库存
    getSkuStockAndStatus(data){
        return req.post("/wxShop/product/getSkuStockAndStatus",{
            ...data
        })
    },
    //价格计算
    calculatePrice(data){
        return req.post("/wxShop/order/calculate",{
            ...data
        })
    },
    //提交进货订单
    createOrder(data){
        return req.post("/wxShop/order/submit",{
            ...data
        })
    },
    //配货订单列表
    getorderlist(data){
        return req.get("/wxShop/order/list",{
            ...data
        })
    },
    //订单列表数量统计
    getordernum(data){
        return req.get("/wxShop/order/statusNum",{
            ...data
        })
    },
    //订单详情
    getorderdetail(data){
        return req.get("/wxShop/order/info",{
            ...data
        })
    },
    //退款
    refund(data){
        return req.post("/wxShop/order/refund",{
            ...data
        })
    },
    //取消
    cancel(data){
        return req.post("/wxShop/order/cancel",{
            ...data
        })
    },
    //上传支付凭证
    uploadPayImage(data){
        return req.post("/wxShop/order/pay/upload/voucher",{
            ...data
        })
    },
    //获取支付连接
    getpayurl(data){
        return req.post("/wxShop/order/prepay",{
            ...data
        })
    },
    //获取包裹详情
    getShipmentDetail(data){
        return req.get("/wxShop/order/shipment/list",{
            ...data
        })
    },
    //订单确认收获
    received(data){
        return req.post("/wxShop/order/shipment/received",{
            ...data
        })
    },
    //用户订单列表
    getuserorderlist(data){
        return req.get("/wxShop/userOrder/list",{
            ...data
        })
    },
    //用户订单详情
    getuserorderdetail(data){
        return req.get("/wxShop/userOrder/info",{
            ...data
        })
    },
    //用户订单生成支付码
    generatePayCode(data){
        return req.post("/wxShop/userOrder/generatePayCode",{
            ...data
        })
    },

}